import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import axios from "axios";
import { apiBaseUrl } from "network";
import { useParams } from "react-router-dom";
import BasicInfo from "components/BasicInfo";
import OwnerInfo from "components/OwnerInfo";
import Gallery from "components/Gallery";
import QRCodeDisplay from "components/QRCodeDisplay";
import CurrentPlan from "components/CurrentPlan";
import OrderSummary from "components/OrderSummary";
import AnalyticsChart from "components/AnalyticsChart";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { IMAGE_URL } from "network";

const Single = () => {
  const { id } = useParams();
  const [profile, setProfile] = useState(null);
  const [analytics, setAnalytics] = useState(null);
  const [plan, setPlan] = useState(null);
  const [orders, setOrders] = useState([]);


  useEffect(() => {
    fetchData();
  }, [id]);

  const fetchData = async () => {
    const [profileRes, analyticsRes, planRes, ordersRes] =
      await Promise.allSettled([
        axios.get(`${apiBaseUrl}vendor/single/${id}`),
        axios.get(`${apiBaseUrl}vendor/analytics/${id}`),
        axios.get(`${apiBaseUrl}vendor/plan/${id}`),
        axios.get(`${apiBaseUrl}vendor/orders/${id}`),
      ]);

    if (profileRes.status === "fulfilled") {
      setProfile(profileRes.value.data);
    } else {
      console.error(
        "Error fetching profile:",
        profileRes.reason?.response?.data?.message || profileRes.reason.message
      );
    }

    if (analyticsRes.status === "fulfilled") {
      setAnalytics(analyticsRes.value.data);
    } else {
      console.error(
        "Error fetching analytics:",
        analyticsRes.reason?.response?.data?.message ||
          analyticsRes.reason.message
      );
    }

    if (planRes.status === "fulfilled") {
      setPlan(planRes.value.data);
    } else {
      console.warn(
        "Plan not found or error:",
        planRes.reason?.response?.data?.message || planRes.reason.message
      );
      setPlan(null); // fallback: empty or null plan
    }

    if (ordersRes.status === "fulfilled") {
      setOrders(ordersRes.value.data);
    } else {
      console.error(
        "Error fetching orders:",
        ordersRes.reason?.response?.data?.message || ordersRes.reason.message
      );
      setOrders([]); // fallback: empty array
    }
  };

  if (!profile || !analytics) return <div>Loading...</div>;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container spacing={2} padding={2}>
        <Grid item xs={6}>
          <Gallery images={profile.gallery} />
        </Grid>

        <Grid item xs={12} md={6}>
          <BasicInfo
            profile={profile}
            qrImage={IMAGE_URL + profile.qrImage}
            qrCode={profile.qrCode}
            onDataUpdate={fetchData}
          />
        </Grid>
        <Grid item xs={12}>
          <CurrentPlan data={plan} />
        </Grid>

        <Grid item xs={12}>
          <AnalyticsChart analytics={analytics} />
        </Grid>
        <Grid item xs={12}>
          <OrderSummary orders={orders} />
        </Grid>

        {/* <Grid item xs={12} md={6}>
        <OwnerInfo owner={profile.owner} />
      </Grid> */}

        {/* <Grid item xs={12} md={6}>
        <QRCodeDisplay qrImage={IMAGE_URL+profile.qrImage} qrCode={profile.qrCode} />
      </Grid> */}
      </Grid>
      <Footer />
    </DashboardLayout>
  );
};

export default Single;
